import actions from './actions';

const initialState = {
  uploadStatus: false,
  uploadedPrompt: {},
};

const {
  GET_UPLOAD_STATUS_SUCCESS,
  GET_UPLOAD_STATUS_ERR,
  SET_UPLOAD_STATUS_SUCCESS,
  SET_UPLOAD_STATUS_ERR,
  GET_UPLOADED_DOC_PROMPT_SUCCESS,
  GET_UPLOADED_DOC_PROMPT_ERR,
  SET_UPLOADED_DOC_PROMPT_SUCCESS,
  SET_UPLOADED_DOC_PROMPT_ERR,
} = actions;

const pdfDocumentAnalysisReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_UPLOAD_STATUS_SUCCESS:
      return state;
    case GET_UPLOAD_STATUS_ERR:
      return err;
    case SET_UPLOAD_STATUS_ERR:
      return err;
    case SET_UPLOAD_STATUS_SUCCESS:
      return {
        ...state,
        uploadStatus: data,
      };
    case GET_UPLOADED_DOC_PROMPT_SUCCESS:
      return state;
    case GET_UPLOADED_DOC_PROMPT_ERR:
      return err;
    case SET_UPLOADED_DOC_PROMPT_ERR:
      return err;
    case SET_UPLOADED_DOC_PROMPT_SUCCESS:
      return {
        ...state,
        uploadedPrompt: data,
      };
    default:
      return state;
  }
};

export { pdfDocumentAnalysisReducer };
